class Confetto {
  constructor(canvas, ctx) {
    const colors = [ [ 85, 71, 106 ], [ 174, 61, 99 ], [ 219, 56, 83 ], [ 244, 92, 68 ], [ 248, 182, 70 ] ];
    this.xpos    = 0.5;
    this.canvas  = canvas;
    this.ctx     = ctx;

    this.style = colors[~~range(0, 5)];
    this.rgb   = `rgba(${this.style[0]},${this.style[1]},${this.style[2]}`;
    this.r     = ~~range(2, 6);
    this.r2    = 2 * this.r;
    this.replace();
  }

  replace() {
    this.opacity = 0;
    this.dop     = 0.03 * range(1, 4);
    this.x       = range(-this.r2, this.canvas.width - this.r2);
    this.y       = range(-20, this.canvas.height - this.r2);
    this.xmax    = this.canvas.width - this.r;
    this.ymax    = this.canvas.height - this.r;
    this.vx      = (range(0, 2) + (8 * this.xpos)) - 5;
    this.vy      = (0.7 * this.r) + range(-1, 1);
  }

  drawCircle() {
    this.ctx.beginPath();
    this.ctx.arc(this.x, this.y, this.r, 0, (2 * Math.PI), false);
    this.ctx.fillStyle = `${this.rgb},${this.opacity})`;
    this.ctx.fill();
  }

  draw() {
    this.x       = this.x + this.vx;
    this.y       = this.y + this.vy;
    this.opacity =  this.opacity + this.dop;
    if (this.opacity > 1) {
      this.opacity = 1;
      this.dop     = this.dop * -1;
    }

    if ((this.opacity < 0) || (this.y > this.ymax))
      this.replace();

    if (!(this.x > 0 && this.x < this.xmax))
      this.x = (this.x + this.xmax) % this.xmax;

    return this.drawCircle();
  }
}


export default class Confetti {
  constructor(canvas) {
    this.stopAnimating    = true;
    this.confetti         = [];
    this.numberOfConfetti = 200;
    this.canvas           = canvas;
    this.canvas.width     = window.innerWidth;
    this.canvas.height    = window.innerHeight;
    this.ctx              = this.canvas.getContext('2d');
  }

  start() {
    this.canvas.style.display = 'block';
    this.stopAnimating        = false;
    this.confetti             = [];
    for (let i = 0; i < this.numberOfConfetti; i++)
      this.confetti.push(new Confetto(this.canvas, this.ctx));

    this.render();
  }

  stop() {
    this.stopAnimating        = true;
    this.canvas.style.display = 'none';
  }

  render() {
    if (this.stopAnimating || !this.ctx)
      return;

    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    Array.from(this.confetti).map(c => c.draw());
    window.requestAnimationFrame(() => this.render());
  }
}

function range(a, b) {
  return ((b - a) * Math.random()) + a;
}
